const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'

const parseResponse = async (response, fallbackMessage) => {
	const text = await response.text()
	let payload = null
	if (text) {
		try {
			payload = JSON.parse(text)
		} catch {
			payload = null
		}
	}
	if (!response.ok) {
		throw new Error(payload?.message || fallbackMessage)
	}
	return payload
}

const getStoreApiPath = (orgSlug, experienceSlug) =>
	`${BASE_URL}/api/store/${encodeURIComponent(orgSlug)}/experiences/${encodeURIComponent(experienceSlug)}`

export const getExperienceStore = async (orgSlug, experienceSlug, signal) => {
	const response = await fetch(getStoreApiPath(orgSlug, experienceSlug), {
		signal,
	})
	return parseResponse(response, 'Failed to load this experience store.')
}

export const createExperienceStoreCheckout = async (
	orgSlug,
	experienceSlug,
	payload,
) => {
	const response = await fetch(
		`${getStoreApiPath(orgSlug, experienceSlug)}/checkout`,
		{
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(payload),
		},
	)
	return parseResponse(response, 'Failed to start checkout.')
}

export const getExperienceStoreOrderStatus = async (
	orgSlug,
	experienceSlug,
	orderId,
	sessionId,
	signal,
) => {
	const query = new URLSearchParams({ session_id: sessionId })
	const response = await fetch(
		`${getStoreApiPath(orgSlug, experienceSlug)}/orders/${encodeURIComponent(orderId)}/status?${query.toString()}`,
		{ signal },
	)
	return parseResponse(response, 'Failed to confirm checkout status.')
}
